import { SheetDataSource } from '@budget/core';
import { getToken, lock } from '../auth/PasswordGate';
import {
  clearDeviceToken,
  getDeviceToken,
  isOnKioskRoute,
} from '../auth/deviceToken';

const tabs = {
  spending: (import.meta.env.VITE_SHEET_SPENDING_TAB as string | undefined) ?? 'Spending',
  cashIn: (import.meta.env.VITE_SHEET_CASHIN_TAB as string | undefined) ?? 'Cash In',
  netWorth: (import.meta.env.VITE_SHEET_NETWORTH_TAB as string | undefined) ?? 'Net Worth',
  incomeHistory:
    (import.meta.env.VITE_SHEET_INCOME_HISTORY_TAB as string | undefined) ?? 'Income by Year',
  incomeByJob:
    (import.meta.env.VITE_SHEET_INCOME_BY_JOB_TAB as string | undefined) ?? 'Income by Job',
  cashOut: (import.meta.env.VITE_SHEET_CASHOUT_TAB as string | undefined) ?? 'Cash Out',
  assets: (import.meta.env.VITE_SHEET_ASSETS_TAB as string | undefined) ?? 'Assets',
  stocksCrypto:
    (import.meta.env.VITE_SHEET_STOCKSCRYPTO_TAB as string | undefined) ?? 'Stocks & Crypto',
  debts: (import.meta.env.VITE_SHEET_DEBTS_TAB as string | undefined) ?? 'Debts',
  links:
    (import.meta.env.VITE_SHEET_LINKS_TAB as string | undefined) ?? 'Links',
  bills:
    (import.meta.env.VITE_SHEET_BILLS_TAB as string | undefined) ?? 'Bills',
  gifts:
    (import.meta.env.VITE_SHEET_GIFTS_TAB as string | undefined) ?? 'Gifts',
  retirementDakota:
    (import.meta.env.VITE_SHEET_RETIREMENT_DAKOTA_TAB as string | undefined) ??
    'Retirement (Dakota)',
  retirementNatalia:
    (import.meta.env.VITE_SHEET_RETIREMENT_NATALIA_TAB as string | undefined) ??
    'Retirement (Natalia)',
  socialSecurity:
    (import.meta.env.VITE_SHEET_SOCIALSECURITY_TAB as string | undefined) ??
    'Social Security',
};

// The data source is shared between the budget app and the /kiosk route.
// Pick the appropriate credential by route: kiosk → device token; otherwise
// the user's session token. 401 handling clears whichever credential is in
// play, then reloads so the right gate (PasswordGate or KioskEnroll) shows.
export const dataSource = new SheetDataSource({
  endpoint: '/api/sheet',
  tabs,
  getToken: () => (isOnKioskRoute() ? getDeviceToken() : getToken()),
  onAuthError: () => {
    if (isOnKioskRoute()) {
      clearDeviceToken();
    } else {
      lock();
    }
    if (typeof window !== 'undefined') window.location.reload();
  },
});
